import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { fetchMe } from 'redux/users/actions';
import {
  connectStripeAccount,
  clearConnectStripeAccount,
} from 'redux/commerce/actions';

import { withRouter } from 'react-router-dom';

import CommonLoader from 'components/common/CommonLoader';

class ConnectStripePage extends Component {
  static propTypes = {
    fetchMe: PropTypes.func.isRequired,
    connectStripeAccount: PropTypes.func.isRequired,
    clearConnectStripeAccount: PropTypes.func.isRequired,
    location: PropTypes.object,
    history: PropTypes.object,
    connectStripeAccountSuccess: PropTypes.object,
  };

  static defaultProps = {
    location: null,
    history: null,
    connectStripeAccountSuccess: null,
  };

  componentDidMount() {
    this._connectStripe();
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.connectStripeAccountSuccess &&
      prevProps.connectStripeAccountSuccess !== this.props.connectStripeAccountSuccess
    ) {
      this.props.fetchMe();
      this.props.clearConnectStripeAccount();
      this.props.history.push('/settings');
    }
  }

  _connectStripe = () => {
    const connectionData = this.props.location.search.split('&');
    if(connectionData[1].includes('code')) {
      const code = connectionData[1].replace('code=', '');
      const currencyId = connectionData[2].replace('state=', '');
      this.props.connectStripeAccount({
        code,
        currency_id: currencyId,
      });
    } else {
      this.props.fetchMe();
      this.props.clearConnectStripeAccount();
      this.props.history.push('/settings');
    }
  };

  render() {
    return (
      <CommonLoader
        active
        text="Stripe Connection..."
      />
    );
  }
}

const mapStateToProps = state => (
  {
    connectStripeAccountSuccess: state.commerceReducer.connectStripeAccountSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    connectStripeAccount,
    clearConnectStripeAccount,
  },
)(withRouter(ConnectStripePage));
